import { Common } from '@trimblemaps/trimblemaps-js';
import { Token } from '../../_models/authws/authws';

export enum SubscriptionLevel {
  PREMIUM = 'Premium',
  STANDARD = 'Standard',
}
export enum Roles {
  COMPANY_ADMINISTRATOR = 'Company Administrator',
  USER = 'User',
  ADMIN = 'Admin',
  ALK_ADMINISTRATOR = 'ALK Administrator',
}
export enum AccountType {
  TRIAL = 'Trial',
  PCMWEB = 'PCMWeb',
}
export enum Zone {
  NA = 'America/New_York',
  EU = 'Europe/Paris',
}
export interface UserInfo {
  promo: boolean;
  hasBillingIssue: boolean;
  creditExpiredDate: string;
  lastName: string;
  firstName: string;
  maxNumberOfUsers: number;
  subscriptionLevel: SubscriptionLevel;
  id: number;
  accountId: number;
  userName: string;
  expired: boolean;
  password: string;
  username: string;
  accountName: string;
  email: string;
  account: string;
  authToken: string;
  currentTermsOfUseAccepted: boolean;
  expiresAt: Date;
  loggedInAt: Date;
  roles: string[];
  userId?: number;
  region?: keyof typeof Common.Region;
  isMonthlyPaidCustomer?: boolean;
  accountType?: AccountType;
  remainingRoutes?: number;
  expirationDate?: string;
  dataset?: (typeof Common.DataVersion)[keyof typeof Common.DataVersion];
  netSuiteOnline?: boolean;
  isInvoiced?: boolean;
  isTripDirectEnabled?: boolean;
  _jwtToken: Token; // Because it is not a part of PCM web service data.user model response, naming it differently to avoid collision.
}
export interface UserDetails extends UserInfo {
  status?: string;
  userInfo?: UserInfo;
}
